export default function PreviewExerciserAssignmentText() {
    // Used in PreviewExerciserSideBar to display test
    // assignments

    // BUILD
    return (
        <div className={"mt-[16px] w-full px-[12px]"}>
            <ul className="w-full list-disc list-outside flex flex-col justify-start items-start space-y-[8px] text-[14px] text-greyLight9 font-normal">
                <li>
                    {"Pour regénérer de nouvelles questions, rafraichir la page"}
                </li>
                <li>
                    {"Donner toute les réponses justes et vérifier la correction"}
                </li>
                <li>
                    {"Donner des réponses fausses et vérifier la correction"}
                </li>
                <li>
                    {"Tenter des réponses improbables (plusieurs virgules ou 0 à la suite)"}
                </li>
                <li>
                    {"Éprouver le clavier de réponse"}
                </li>
            </ul>
        </div>
    );
}